export interface ParseFormationOptions {
  includeGoalkeeper?: boolean;
  enforceOutfieldSum?: boolean;
  maxLines?: number;
}

/** Quick check: does a string look like a formation (contains at least two numbers)? */
export function looksLikeFormation(input?: string | null): boolean {
  if (!input) return false;
  const nums = input.match(/\d+/g);
  return !!nums && nums.length >= 2;
}

/** Parse a formation string into an array of numbers (rows). */
export function parseFormation(
  formation?: string | null,
  options?: ParseFormationOptions
): number[] {
  const opt: Required<ParseFormationOptions> = {
    includeGoalkeeper: false,
    enforceOutfieldSum: true,
    maxLines: Number.POSITIVE_INFINITY,
    ...options,
  };

  if (!formation) return [];

  // Extract all integer tokens in order (handles "4-2-3-1", "4 / 4 / 2", "4–2–3–1", etc.)
  const rawNums = formation.match(/\d+/g);
  if (!rawNums) return [];

  let rows = rawNums
    .map((n) => Number(n))
    .filter((n) => Number.isFinite(n) && n > 0);

  // Drop a leading GK if not requested (so "1-4-3-3" → [4,3,3])
  if (!opt.includeGoalkeeper && rows.length > 0 && rows[0] === 1) {
    rows = rows.slice(1);
  }

  // Sanity check: if sum === 11 and first === 1 (some weird inputs), remove GK again
  if (opt.enforceOutfieldSum && !opt.includeGoalkeeper) {
    if (rows.length > 0 && rows[0] === 1 && sum(rows) === 11) {
      rows = rows.slice(1);
    }
  }

  // Trim to maxLines (guard against noisy strings)
  if (Number.isFinite(opt.maxLines)) {
    rows = rows.slice(0, opt.maxLines);
  }

  return rows;
}

/** Validate that the array sums to 10 outfield players. */
export function validateOutfieldSum(rows: number[]): boolean {
  return sum(rows) === 10;
}

/** Format rows back to a canonical string, e.g., [4,2,3,1] -> "4-2-3-1". */
export function formatFormation(rows: number[]): string {
  return rows.join("-");
}


function sum(arr: number[]): number {
  let s = 0;
  for (let i = 0; i < arr.length; i++) s += arr[i];
  return s;
}


